/** Kategorisierung der Crime-Ops-Sub-Tabs für Mobile-Accordion (Prompt 01). */

export const CRIME_OPS_CATEGORIES = [
  { id: 'handel',     label: 'HANDEL',     tabs: ['dealer', 'auftraege', 'strassenhandel', 'schwarzmarkt', 'darknet'] as const },
  { id: 'produktion', label: 'PRODUKTION', tabs: ['labor', 'schmuggel', 'gewächshaus', 'rolltisch'] as const },
  { id: 'verwaltung', label: 'VERWALTUNG', tabs: ['geldwaesche', 'immobilien', 'viertel', 'kontakte'] as const },
] as const;

/** Alle kategorisierten Tab-IDs (Börse bewusst ausgeschlossen — wird in Prompt 07 verschoben). */
export const CRIME_OPS_CATEGORIZED_IDS: readonly string[] = CRIME_OPS_CATEGORIES.flatMap((c) => c.tabs);

/**
 * Gibt die Kategorie-ID zurück, in der `section` liegt.
 * Liefert `null` für nicht-kategorisierte Tabs (aktuell: 'boerse').
 */
export function getCategoryForSection(section: string): string | null {
  for (const cat of CRIME_OPS_CATEGORIES) {
    if ((cat.tabs as readonly string[]).includes(section)) return cat.id;
  }
  return null;
}
